
//import createHistory from 'history/createBrowserHistory';
import { createBrowserHistory } from 'history';
import EventEmitter from 'events';

import { ui } from '../Infrastructure/config';

const events = new EventEmitter();

const history = createBrowserHistory({ basename: ui.basename })
//const history = createHistory({ basename: ui.basename });

export const getHistory = () => history;

export const getEventEmitter = () => events;

export const cleanUpHTML = html => {
  return html
  .replace(/\n/g, "")
  .replace(/[\t ]+</g, " <")
  .replace(/>[\t ]+</g, "><")
  .replace(/>[\t ]+$/g, ">");
};

export const chunk = (arr, size) =>
arr
  .reduce((acc, _, i) =>
    (i % size)
      ? acc
      : [...acc, arr.slice(i, i + size)]
  , [])